import Home from "./pages/Home"

const Pages = {
  Home: Home,
}

export default Pages
